var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.927734,
    y: 16,
    width: 25.0174,
    height: 2,
    rx: 1,
    fill: "#191919"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.927734,
    y: 8,
    width: 25.0174,
    height: 2,
    rx: 1,
    fill: "#191919"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.927734,
    width: 25.0174,
    height: 2,
    rx: 1,
    fill: "#191919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleButton);
export default __webpack_public_path__ + "static/media/toggle-button.119009acfaf8ce1b7b9f2c087b0bfd99.svg";
export { ForwardRef as ReactComponent };